// removed by extract-text-webpack-plugin
module.exports = {"settings":"settings--35W77","SettingsTitle":"SettingsTitle--3La3t","setting":"setting--16FB7","SettingCards":"SettingCards--1BX2u","Loading":"Loading--2lDc6"};